import { useNavigate } from 'react-router-dom';

import { PermissionsEnum } from '@/auth/interfaces';
import { EstadosOrdenTrabajoEnumChoice, ROUTER_PATHS } from '@/shared';
import { GeneralTable, TableTabsScene } from '@/shared/components/ui';
import {
  useCheckPermissions,
  useTableServerSideFiltering,
} from '@/shared/hooks';
import { useTableFilter } from '@/shared/hooks/useTableFilter';
import { hasPermission } from '@/shared/utils';
import { IOrdenServicioCorporativo } from '@/shared/interfaces/erp/orden_servicio_corporativo';
import { useGetOrdenServicioCorporativo } from '@/shared/actions/erp/tecnico/orden_servicio_corporativo';
import { useTableColumnsOrdenTrabajoCorporativo } from '@/shared/hooks/useTableColumnsOrdenTrabajoCorporativo';

type TableOrdenServicioCorpProps = {
  stateAgendamiento?: EstadosOrdenTrabajoEnumChoice;
};

const TableOrdenServicioCorp: React.FC<TableOrdenServicioCorpProps> = ({
  stateAgendamiento = EstadosOrdenTrabajoEnumChoice.EN_ESPERA,
}) => {
  const navigate = useNavigate();
  useCheckPermissions(PermissionsEnum.api_view_agendamiento)

  // server side filters - colums table
  const { filterObject, columnFilters, setColumnFilters } =
    useTableServerSideFiltering();

  ///* table
  const {
    globalFilter,
    pagination,
    searchTerm,
    onChangeFilter,
    setPagination,
    cleanFilter,
  } = useTableFilter();
  const { pageIndex, pageSize } = pagination;

  ///* fetch data
  const {
    data: agendamientosPagingRes,
    isLoading,
    isRefetching,
  } = useGetOrdenServicioCorporativo({
    enabled: true,
    params: {
      page: pageIndex + 1,
      page_size: pageSize,
      identificacion: searchTerm,
      ...filterObject,
      filterByState: false,
      estado_agenda: stateAgendamiento,
    },
  });

  ///* columns
  const { columnsAgendaCoporativo } =
    useTableColumnsOrdenTrabajoCorporativo(stateAgendamiento)


  return (
    <TableTabsScene
      globalFilter={globalFilter}
      onChangeFilter={onChangeFilter}
      searchInputText="por identificación"
      //onChangeRangeDate={onChangeRangeDate}
      cleanFilter={cleanFilter}
    >
      <GeneralTable<IOrdenServicioCorporativo>
        columns={
          columnsAgendaCoporativo
        }
        data={agendamientosPagingRes?.data.data ?? []}
        isLoading={isLoading}
        isRefetching={isRefetching}
        // // filters - server side
        enableManualFiltering={true}
        columnFilters={columnFilters}
        onColumnFiltersChange={setColumnFilters}
        // // search
        enableGlobalFilter={false}
        // // pagination
        pagination={pagination}
        onPaging={setPagination}
        rowCount={agendamientosPagingRes?.data?.count}
        // // // actions ========
        enableColumnActions={true}
        enableEditing={true}
        // crud
        canEdit={hasPermission(PermissionsEnum.api_change_agendamiento)}
        onEdit={(row) => {

          navigate(
            `${ROUTER_PATHS.tecnico.ordenenTrabajoAsignadasCorpNav}/${row.id_orden_servicio_corporativo}`
          );
        }}
        canDelete={false}
      />
    </TableTabsScene>
  );
};

export default TableOrdenServicioCorp;
